export namespace TransferConstant {
  export const MAX_AMOUNT = 50000;
}
